var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96295 4.71569C9.99712 3.78588 10.2584 2.96916 10.7405 2.28644C11.2251 1.60025 12.0262 1.11281 13.1227 0.836609C13.13 0.870376 13.1376 0.904163 13.1455 0.937821V1.11449C13.1455 1.51509 13.0483 1.97445 12.8565 2.47972C12.6555 2.96894 12.3414 3.42939 11.9242 3.84495C11.534 4.2111 11.173 4.45352 10.8539 4.5631C10.7486 4.59456 10.6042 4.62552 10.4297 4.6534C10.2746 4.67756 10.119 4.69835 9.96295 4.71569Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1459 6.0954C8.90727 6.0954 8.04731 4.99994 6.82552 4.99994C5.60377 4.99994 3.08673 6.12294 3.08673 9.99994C3.08673 13.8769 5.3219 16.3749 5.5719 16.6666C5.82186 16.9583 6.40002 17.7081 7.29573 17.7081C8.19148 17.7081 9.17211 16.9959 10.1459 16.9959C11.1196 16.9959 12.3453 17.7081 13.1455 17.7081C13.9456 17.7081 14.2748 17.3819 14.8194 16.8192C15.3639 16.2566 16.4026 14.5396 16.7654 13.5091C16.1679 13.1535 14.5842 12.1879 14.5842 9.99994C14.5842 8.54131 15.1172 7.32952 16.1834 6.36465C15.4839 5.45486 14.6728 4.99994 13.7498 4.99994C12.3654 4.99994 11.3845 6.0954 10.1459 6.0954Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.84306466fcd0f727865e2b121d0d156c.svg";
export { ForwardRef as ReactComponent };